const project = {
  ui: {
    contactcard: true,
    infopanel: true,
    bottomnav: true,
    projecttitle: 'measured by Sensar, visualised by Klaas Nienhuis',
    headerlogo: 'assets/Final_Sensar_Logo.png',
    headerlink: 'https://sensar.nl/',
    background: {
      image: '/Med_vt_rv.png',
      color: '#5F2E2E',
      type: 'sketchfab'
    }    
  },
  scenes: [
    {
      scenetitle: 'Land Subsidence in Ho Chi Minh',
      header: '3D visualizations are great for flood risk analysis or terrain movement visualization due to underground gas storage or earthquakes.',
      sceneuid: '8df985baba584ed2a209db4f5757af92',
      subheader: 'By Klaas Nienhuis',
      banner: 'assets/mekongdelta.jpg',
      view: 'start',

      menu: [
        // {
        //   name: 'mtl',
        //   title: 'Materials',
        //   icon: 'mdi-palette',
        //   options: [
        //     {material: 'terrain_mekong'}
        //   ]
        // },
        {
          name: 'sensar',
          title: 'Land Subsidence',
          icon: 'mdi-terrain',
          initialOpen: true,
          options: [
            {sensar: 'hochiminh'},
            {material: 'terrain_mekong'}
          ]
        },
        // {
        //   name: 'cam',
        //   title: 'Views',
        //   icon: 'mdi-camera',
        //   options: [
        //     {view: 'start'}
        //   ]
        // }
      ],
      player: {template: 'sensar', payload: {}},
      background: {template: 'sensar', payload: {}},
      environment: {template: 'lojer', payload: {}},
      postprocessing: {template: 'lojer', payload: {}},
      annotations: []      
    }
  ]
}

export default project;